<template>
	<v-container>
		<v-card>
			<v-card-text>
				<v-switch
					v-model="settings.darkMode"
					label="Tumma väriteema"
				/>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>

export default {
	name: 'Settings',
	data: () => ({
		settings: {},
	}),
	mounted () {
		// Get current settings from the store
		this.settings = this.$store.state.settings
	},
	watch: {
		settings: {
			deep: true,
			handler (val) {
				// When settings change, save them to store
				this.$store.dispatch('setSettings', val)
			}
		},
	}
};
</script>
